export enum Breakpoints {
    phone = 768,
    tablet = 1024,
    laptop = 1366,
    desktop = 1920,
}
